import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { getLeadUid } from 'site-modules/shared/components/lead-form/utils/utils';
import { numberWithCommas } from 'site-modules/shared/utils/string';
import { getVehicleLabel } from 'site-modules/shared/components/lead-form/utils/get-vehicle-label';
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';

export function DealerVinCardSrpUsed({ leadTarget, isInStockOnline = false, specialIdentifier = '' }) {
  const { dealer, inventory, leadAttributes } = leadTarget;

  const distance = get(leadAttributes, 'distance');
  const dealerInfo = get(inventory, 'dealerInfo', dealer);
  const { vin, vehicleInfo } = inventory;

  const salesOverallRating = get(dealerInfo, 'displayInfo.salesOverallRating', get(dealerInfo, 'salesRating', 0));
  const salesReviewCount = get(dealerInfo, 'displayInfo.salesReviewCount', get(dealerInfo, 'salesReviewCount', 0));
  const displayPrice = get(inventory, 'prices.advertisedPrice');

  const uid = getLeadUid(leadTarget);

  const vehicleMileage = get(vehicleInfo, 'mileage');

  const NO_PRICE = 'No price';

  return (
    <div className="align-items-center size-14 text-cool-gray-40 w-100">
      <div className="mb-0_75 mb-md-1">
        <h3 className="size-16 text-cool-gray-40 fw-bold mb-0_25">
          {getVehicleLabel({ vehicleInfo, specialIdentifier })}
        </h3>
        <div className="mb-0_25">
          <span className="me-0_25">{displayPrice ? formatPriceString(displayPrice) : NO_PRICE}</span>|
          {vehicleMileage && <span className="ms-0_25">{numberWithCommas(vehicleMileage)} mi</span>}
        </div>
        {!!vin && <div className="break-word">VIN: {vin}</div>}
      </div>
      <div>
        <div className="size-14 text-cool-gray-40 fw-normal mb-0_25" id={uid}>
          {dealerInfo.name}
          {distance > 0 && (
            <span className="ms-0_25">
              {isInStockOnline ? '(In-stock online)' : `(${numberWithCommas(distance)} mi)`}
            </span>
          )}
        </div>

        {!!salesReviewCount && (
          <div>
            <RatingStars rating={salesOverallRating} className="text-primary-darker me-0_25" />
            <span>({salesReviewCount})</span>
          </div>
        )}
      </div>
    </div>
  );
}

DealerVinCardSrpUsed.propTypes = {
  leadTarget: PropTypes.shape({
    inventory: PropTypes.shape({}),
    dealer: PropTypes.shape({}),
    leadAttributes: PropTypes.shape({
      primary: PropTypes.bool.isRequired,
      selected: PropTypes.bool.isRequired,
      distance: PropTypes.number,
    }).isRequired,
  }).isRequired,
  isInStockOnline: PropTypes.bool,
  specialIdentifier: PropTypes.string,
};
